// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:segments*?\",\"regex\":\"^/(.*)$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/preview/:segments*?\",\"regex\":\"^/admin/preview(?:/(.*))?$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false},{\"path\":\"/blog/:page\",\"regex\":\"^/blog/([^/]+)$\",\"paramNames\":[\"page\"],\"hasOptionalPrefix\":false},{\"path\":\"/post/:segments*?\",\"regex\":\"^/post(?:/(.*))?$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false},{\"path\":\"/admin/:segments*?\",\"regex\":\"^/admin(?:/(.*))?$\",\"paramNames\":[\"segments\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/blog\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.3";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://7213a2b074d337b1e3a603504c03706b@o4511417840828416.ingest.de.sentry.io/4511422345904208",

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  enabled: process.env.NODE_ENV !== "development",
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
